// extracted by mini-css-extract-plugin
export default {"massUploadSummary":"massUpload_massUploadSummary__apE8g","massUploadSummaryDetails":"massUpload_massUploadSummaryDetails__vU3d8"};